import React from 'react';

const NavLink = ({to, selected = false, current, onClick, ...props}) => {

    const handleClick = () => {
        if(onClick){
            onClick();
            return;
        }
        if (to || to === "") {
            window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN + to;
        }
    }

    return (
        <div
            className={`cursor-pointer py-6 border-b-2 ${to === current ? "border-white" : "border-transparent"} hover:border-white`}
            onClick={handleClick}>
            {props.children}
        </div>
    );
}

export default NavLink;